/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI Sales
 * Это Sales api сервер, для запросов от Frontend.  Для запросов требуется указать header с Authorization и типом Bearer.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
import type { Sale } from './Sale'
import {
  SaleFromJSON,
  SaleFromJSONTyped,
  SaleToJSON,
  SaleToJSONTyped,
} from './Sale'
import type { ResponseEnterpriseGetListMeta } from './ResponseEnterpriseGetListMeta'
import {
  ResponseEnterpriseGetListMetaFromJSON,
  ResponseEnterpriseGetListMetaFromJSONTyped,
  ResponseEnterpriseGetListMetaToJSON,
  ResponseEnterpriseGetListMetaToJSONTyped,
} from './ResponseEnterpriseGetListMeta'

/**
 *
 * @export
 * @interface ResponseSaleGetList
 */
export interface ResponseSaleGetList {
  /**
   *
   * @type {boolean}
   * @memberof ResponseSaleGetList
   */
  success: boolean
  /**
   *
   * @type {Array<Sale>}
   * @memberof ResponseSaleGetList
   */
  data?: Array<Sale>
  /**
   *
   * @type {ResponseEnterpriseGetListMeta}
   * @memberof ResponseSaleGetList
   */
  meta?: ResponseEnterpriseGetListMeta
  /**
   *
   * @type {string}
   * @memberof ResponseSaleGetList
   */
  errorMessage?: string
  /**
   *
   * @type {number}
   * @memberof ResponseSaleGetList
   */
  codeError?: number
}

/**
 * Check if a given object implements the ResponseSaleGetList interface.
 */
export function instanceOfResponseSaleGetList(
  value: object,
): value is ResponseSaleGetList {
  if (!('success' in value) || value['success'] === undefined) return false
  return true
}

export function ResponseSaleGetListFromJSON(json: any): ResponseSaleGetList {
  return ResponseSaleGetListFromJSONTyped(json, false)
}

export function ResponseSaleGetListFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ResponseSaleGetList {
  if (json == null) {
    return json
  }
  return {
    success: json['success'],
    data:
      json['data'] == null
        ? undefined
        : (json['data'] as Array<any>).map(SaleFromJSON),
    meta:
      json['meta'] == null
        ? undefined
        : ResponseEnterpriseGetListMetaFromJSON(json['meta']),
    errorMessage:
      json['errorMessage'] == null ? undefined : json['errorMessage'],
    codeError: json['codeError'] == null ? undefined : json['codeError'],
  }
}

export function ResponseSaleGetListToJSON(json: any): ResponseSaleGetList {
  return ResponseSaleGetListToJSONTyped(json, false)
}

export function ResponseSaleGetListToJSONTyped(
  value?: ResponseSaleGetList | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value
  }

  return {
    success: value['success'],
    data:
      value['data'] == null
        ? undefined
        : (value['data'] as Array<any>).map(SaleToJSON),
    meta: ResponseEnterpriseGetListMetaToJSON(value['meta']),
    errorMessage: value['errorMessage'],
    codeError: value['codeError'],
  }
}
